'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');


/**
 * IPad
 */
var IPad = React.createClass({

  render: function () {
    var move;
    var isVerticalScreen = this.props.direction === appTypes.Direction.VERTICAL;
    var size = styleHelper.getSize(this.props);
    var r = util.Rect.create(34,53,472,582);
    var ms = util.Size.create(537,702);
    if(!isVerticalScreen){
      util.Rect.overturn(r);
      util.Size.overturn(ms);
    }
    var sw = size.width/ms.width;
    var sh = size.height/ms.height;
    util.Rect.scale(r,sw,sh);
    util.Rect.inflate(r,5,5);



    var imgStyle = {
      width: isVerticalScreen ? size.width : size.height,
      height: isVerticalScreen ? size.height : size.width,
      position:'absolute',
      pointerEvents:'none',
      zIndex:1
    };

    var bgStyle={
      width: r.width,
      height: r.height,
      top: r.top,
      left: r.left,
      position:'absolute',
      zIndex:0,
      backgroundColor:styleHelper.getBackgroundColor(this.props)
    };
    if (!isVerticalScreen) {
      move = (size.width - size.height) / 2;
      imgStyle.transform = 'rotate(270deg) translate(' + move + 'px,' + move + 'px)'
    }

    return (<div className="component">
      <div style={bgStyle}></div>
      <img src={assetsHelper.getComponentAsset('ipad')}
           style={imgStyle}
      />
    </div>);
  }

});

module.exports = IPad;



// WEBPACK FOOTER //
// ./src/views/Components/IPad.jsx